import { Content } from 'src/contexts/ContentContext';
import { ContentId } from 'src/utils/constants/contentId';

import { useAlertWithSuppressionDialog } from './useAlertWithSuppressionDialog';

export function useMergeGroupedListingDialog(
  onOkay: () => void,
  onCancel: () => void
) {
  const { value, ...rest } = useAlertWithSuppressionDialog(
    'mergedGroupListingTimestamp',
    onOkay,
    onCancel
  );
  return {
    ...rest,
    lastTimeStamp: value?.mergedGroupListingTimestamp,
    bodyText: <Content id={ContentId.MergedGroupListingWarning} />,
    cancelText: <Content id={ContentId.No} />,
  };
}
